
export default class LazyLoad {
  constructor(context, callback) {
    this.context = context;
    this.callback = callback;
    this.init();
  }

  init() {
    const lazyImages = Array.from(this.context.querySelectorAll('[data-src]'));

    const lazyImageObserver = new IntersectionObserver((entries) => {
      entries.forEach( (entry) => {
        if (entry.isIntersecting) {
          const lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
          lazyImage.removeAttribute('data-src');
          lazyImage.classList.add('_media-loaded');
          lazyImageObserver.unobserve(lazyImage);
          this.callback()
        }
      });
    },
    {
			root: null,
			rootMargin: window.innerHeight + 'px',
			threshold:  0
    });

    lazyImages.forEach((lazyImage) => {
      lazyImageObserver.observe(lazyImage);
    });
  }
}
